import {
  type OrderGetOrderDetailsOrderItemReadDto,
  type OrderItemDetailsReadDto,
} from "@/config/apiClient";
import { type RetroplanningStatusEnum } from "@/config/apiClient.types";

// Get the due date of the retroplanning item with the given status
export const getRetroplanningDueDate = (
  orderItem: OrderItemDetailsReadDto | OrderGetOrderDetailsOrderItemReadDto,
  statusToCheck: RetroplanningStatusEnum
) => {
  if (
    "retroplanning" in orderItem &&
    orderItem.retroplanning?.isSharedAt &&
    orderItem.retroplanning.retroplanningItems
  ) {
    const retroplanningItem = orderItem.retroplanning.retroplanningItems.find(
      (i) => i.status === statusToCheck
    );

    return retroplanningItem?.dueDate;
  }

  return undefined;
};
